export { unsplashService } from './unsplash';
export { hitokotoService } from './hitokoto';
export { cacheService } from './cache';
export { lunarService } from './lunar';

// 主要的内容获取服务
import { unsplashService } from './unsplash';
import { hitokotoService } from './hitokoto';
import { cacheService } from './cache';
import { DailyContent, ProcessedImage, ProcessedQuote } from '@/types';

class ContentService {
  private loadingPromise: Promise<DailyContent> | null = null;

  async getDailyContent(): Promise<DailyContent> {
    // 首先检查缓存
    const cached = cacheService.get();
    if (cached) {
      console.log('使用缓存内容');
      return cached;
    }

    // 防止重复请求 - 如果已经在加载中，返回同一个 promise
    if (this.loadingPromise) {
      console.log('等待现有请求完成...');
      return this.loadingPromise;
    }

    console.log('获取新内容');
    
    // 创建加载 promise
    this.loadingPromise = this.loadNewContent();
    
    try {
      const result = await this.loadingPromise;
      return result;
    } finally {
      // 清除 loading promise，允许后续请求
      this.loadingPromise = null;
    }
  }

  private async loadNewContent(): Promise<DailyContent> {
    // 并行获取图片和文字
    const [image, quote] = await Promise.all([
      this.getImage(),
      this.getQuote()
    ]);

    const content: DailyContent = {
      date: new Date().toISOString(),
      quote,
      image
    };

    // 保存到缓存
    cacheService.set(content);

    return content;
  }

  private async getImage(): Promise<ProcessedImage> {
    try {
      return await unsplashService.getImage();
    } catch (error) {
      console.error('图片获取失败:', error);
      // 返回默认图片
      return {
        url: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=2400&q=95',
        photographer: 'Unsplash',
        photographer_url: 'https://unsplash.com',
        photo_url: 'https://unsplash.com'
      };
    }
  }

  private async getQuote(): Promise<ProcessedQuote> {
    try {
      return await hitokotoService.getQuote();
    } catch (error) {
      console.error('文字获取失败:', error);
      // 返回默认文字
      return {
        text: '山重水复疑无路，柳暗花明又一村。',
        source: '陆游，《游山西村》'
      };
    }
  }

  // 强制刷新内容
  async refreshContent(): Promise<DailyContent> {
    // 清除缓存和正在进行的请求
    cacheService.clear();
    this.loadingPromise = null;
    return this.getDailyContent();
  }

  // 触发 Unsplash 下载事件
  async triggerImageDownload(downloadLocation?: string): Promise<void> {
    if (downloadLocation) {
      await unsplashService.triggerDownload(downloadLocation);
    }
  }
}

export const contentService = new ContentService();